import { render, staticRenderFns } from "./CardReportInfo.vue?vue&type=template&id=356ac696&"
import script from "./CardReportInfo.vue?vue&type=script&lang=js&"
export * from "./CardReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardReportInfo.vue?vue&type=style&index=0&id=356ac696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports